<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i class="fa fa-filter" aria-hidden="true"></i>
          <span class="title">{{ 'ADMIN.FILTER.TITLE' | translate }}</span>
          <span class="subtitle">{{ 'ADMIN.GENERAL.EPS_USERS' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12">
          <form [formGroup]="userFilterForm">
            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.FIRST_NAME"
                    formControlName="firstName"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.LAST_NAME"
                    formControlName="lastName"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.EMAIL"
                    formControlName="email"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-select
                    label="ADMIN.FILTER.LABELS.SALES_ORGANISATION"
                    formControlName="salesOrganisationIds"
                    [options]="salesOrganisations"
                    [showErrors]="false"
                    hideOptionalMarker
                    multiple
                  ></eps-select>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group row">
                  <eps-label-body label="ADMIN.CLIENT_USERS.ACTIVE" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isActive"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotActive"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.FILTER.LABELS.ASSIGNED" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isAssigned"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotAssigned"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.EPS_USERS.ADMIN" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isAdmin"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotAdmin"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.EPS_USERS.RELOCATION" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="canRelocate"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="cannotRelocate"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.EPS_USERS.SELECT_DEPOT" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="canSelectDepot"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="cannotSelectDepot"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.EPS_USERS.USE_HIDDEN_MATERIALS" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="canSeeHiddenMaterials"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="cannotSeeHiddenMaterials"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
              </div>
            </div>

            <div class="row center-xs end-sm end-lg filter-buttons">
              <eps-button buttonIcon="eraser" (buttonClick)="resetFilter()" [disabled]="isLoading" label="SHARED.BUTTONS.CLEAR_FILTERS"></eps-button>
              <eps-button buttonIcon="filter" (buttonClick)="filterClicked()" [disabled]="userFilterForm.invalid" [busy]="isLoading" submit
                          label="{{'ADMIN.FILTER.TITLE' | translate }} {{ 'ADMIN.GENERAL.EPS_USERS' | translate}}"></eps-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
